import { InfoRounded } from '@mui/icons-material';
import { Alert, Typography } from '@mui/material';

import { alertStyles } from './styles';

export const InfoAlert = ({ message }: { message: string }) => {
  return (
    <Alert icon={<InfoRounded />} severity="info" sx={alertStyles.root}>
      <Typography variant="body3">{message}</Typography>
    </Alert>
  );
};
